import {
  Col,
  ColType,
  Crud,
  CrudOption,
  CrudApi,
  CrudAction,
} from "../../comp/crud";
import {
  ApiClient,
  displayLeadStatus,
  getLeadStatusOpt,
} from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { TextCell } from "../../comp/cell";
import { displayStar } from "../../utils";
import { Tag, Button, Form, Modal, Toast } from "@douyinfe/semi-ui";
import { IconModalStroked } from "@douyinfe/semi-icons";
import React, { useEffect, useMemo, useState } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

export interface LeadImportHitProps {
  source?: string;
  hitSource?: string;
  leadName?: string;
  leadMobile?: string;
  createdAt?: string;
  hitStar?: number;
}
let apiClient = ApiClient.getDefault();
export default function LeadImportLogDetail(props: LeadImportHitProps) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [filterSource, setFilterSource] = useState(true);
  const [filterHitSource, setFilterHitSource] = useState(true);
  const [filterLeadName, setFilterLeadName] = useState(true);
  const [filterCreatedAt, setFilterCreatedAt] = useState(true);
  const [filterLeadMobile, setFilterLeadMobile] = useState(true);
   const [filterHitStar, setFilterHitStar] = useState(true);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");

  let cols: Col[] = [
    {
      name: "姓名",
      key: "leadName",
      hideInEdit: true,
      showInFilter: filterLeadName,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="primary"
            onClick={() => detailAction(record)}
          >
            {value}
          </Button>
        );
      },
    },
    {
      name: "手机号",
      key: "leadMobile",
      hideInEdit: true,
      showInFilter: filterLeadMobile,
      type: ColType.STRING,
    },
    {
      name: "导入渠道",
      key: "source",
      hideInEdit: true,
      showInFilter: filterSource,
      type: ColType.STRING,
    },
    {
      name: "撞库客户ID",
      key: "hitLeadId",
      hideInEdit: true,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "撞库渠道",
      key: "hitSource",
      hideInEdit: true,
      showInFilter: filterHitSource,
      type: ColType.STRING,
    },
    {
      name: "撞库客户星级",
      key: "hitStar",
      width: 100,
      colSort: 5,
      colFilterSort: 5,
      showInFilter: filterHitStar,
      hideInCreate: true,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
      name: "撞库客户状态",
      key: "hitStatus",
      width: 100,
      colSort: 3,
      showInFilter: true,
      colFilterSort: 3,
      hideInCreate: true,
      render: (value, index) => {
        if (value == "PENDING_CONTACT") {
          return (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "UNREACHABLE") {
          return (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "OUT_LEAD") {
          return (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "INVITATION_IN_PROGRESS") {
          return (
            <Tag
              color="orange"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "NON_COMPLIANCE") {
          return (
            <Tag
              color="teal"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PENDING_VISIT") {
          return (
            <Tag
              color="purple"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "VISITED") {
          return (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "SIGNED_CONTRACT") {
          return (
            <Tag
              color="violet"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PAID") {
          return (
            <Tag
              color="yellow"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else {
          return (
            <Tag key={value} size="large" shape="circle" type="solid">
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        }
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "客户入库时间",
      key: "hitCreatedAt",
      showInFilter: false,
      type: ColType.DATE_RANGE,
    },
    {
      name: "导入批次",
      key: "batchNo",
      showInFilter: false,
      type: ColType.DATE_RANGE,
    },
  ];

  const initFilterValues = {
    source: props.source,
    hitSource: props.hitSource,
    leadName: props.leadName,
    leadMobile: props.leadMobile,
    createdAt: props.createdAt,
    hitStar: props.hitStar,
  };
  const initParams = {
    source: props.source,
    hitSource: props.hitSource,
    leadName: props.leadName,
    leadMobile: props.leadMobile,
    createdAt: props.createdAt,
    hitStar: props.hitStar,
  };

  useEffect(() => {
    if (props.source) {
      setFilterSource(false);
    }
    if (props.hitSource) {
      setFilterHitSource(false);
    }
    if (props.leadName && props.leadName != "") {
      setFilterLeadName(false);
    }
    if (props.createdAt && props.createdAt != "") {
      setFilterCreatedAt(false);
    }
    if (props.leadMobile && props.leadMobile != "") {
      setFilterLeadMobile(false);
    }
    if (props.createdAt && props.createdAt != "") {
      setFilterCreatedAt(false);
    }
    if (props.hitStar) {
      setFilterHitStar(false);
    }
    let currUsername;
    if (role == "op_manager" || role == "monitor" || role == "foreground") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));
  }, []);

  //打开详情
  const detailAction = (a: any) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type: "all",
    };
    if (w != null) {
      //获取表格data的id列表
      const ids = crudApi?.getData()?.map((i) => i.hitLeadId);
      const data = {
        id: a.hitLeadId,
        ids: ids,
        viewMode: true,
        visitMode: false,
        leadFrom: "report",
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      setSelectedLeads([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowAssignModal(false);
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handleAssignButtonClick = (row: any, rows: any) => {
    if(rows.length==0){
         Toast.info("请选择客户");
         return;
    }
    let leads = [];
    for (let i = 0; i < rows.length; i++) {
      leads.push({ id: rows[i].hitLeadId, name: rows[i].leadName });
    }
    setSelectedLeads(leads);
    setShowAssignModal(true);
  };

  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };

      const actions: CrudAction[] = [];
  
      actions.push(assignAction);

  const renderLabel = (label: any, item: any) => (
    <div
      style={{
        padding: "6px 8px",
        lineHeight: 1.0,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "var(--semi-color-text-0)",
          fontSize: 14,
        }}
      >
        {label}
        <span
          style={{
            fontSize: 12,
            color: "var(--semi-color-text-2)",
            marginLeft: 10,
          }}
        >
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400,
            }}
          ></Form.TreeSelect>

          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Crud
      getCrudApi={(crudApi) => {
                setCrudApi(crudApi);
              }}
        canUpdate={false}
        canCreate={false}
        canExport={true}
        name="撞库明细"
        entityKey="leadImportLog/queryLeadHitLeadPage"
        initFilterValues={initFilterValues}
        params={initParams}
        actions={actions}
        select={true}
        pageSize={50}
        cols={cols}
      />
    </div>
  );
}
